<div class="streams">
  <video #remoteVideo class="remote" autoplay playsinline></video>
  <video #localVideo class="local" autoplay playsinline muted></video>
</div>
